import React, {FC} from "react"
import {Grid} from "react-bootstrap"

import {Body, H1} from "@irati/ui/src/Typography"
import {FormattedMessage} from "@irati/utils/lang"

import {CustomPaddingCard} from "./styled"

const ContactPreferencesSuccess: FC = () => {
  return (
    <Grid>
      <CustomPaddingCard flush noBorder>
        <H1 marginBottom={1}>
          <FormattedMessage id="platform.contactPreferences.unsubscribed.success.heading" />
        </H1>
        <Body>
          <FormattedMessage id="platform.contactPreferences.unsubscribed.success.body" />
        </Body>
        <Body>
          <FormattedMessage id="platform.contactPreferences.unsubscribed.success.instructionBody" />
        </Body>
      </CustomPaddingCard>
    </Grid>
  )
}

export default ContactPreferencesSuccess
